import { nsHistorics } from '@/app/i18n/namespaces';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import HISTORICS_OUTCOME_TYPE from '../enums/HistoricsOutcomeType';
import HISTORICS_USER_TYPE from '../enums/HistoricsUsersType';

export default {
    COMMON: {
        UUID: {
            key: 'uuid'
        },
        ACTION_TIMESTAMP: {
            key: 'actionTimestamp',
            type: FIELD_TYPES.DATE,
            entity: 'keys.common.action_timestamp',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.DATE
        },
        ORGANIZATION_UUID: {
            key: 'organizationUuid',
            entity: 'historics_organization_uuid'
        },
        ORGANIZATION_LEGAL_NAME: {
            key: 'organizationLegalName',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.common.organization_legal_name',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.common.organization_legal_name'
        },
        ACTION_TYPE: {
            key: 'actionType',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.common.action_type',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.SELECT,
            prefix: 'historics_action_type_'
        },
        USER_EMAIL: {
            key: 'userEmail',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.common.user_email',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.common.user_email'
        },
        ATTRIBUTES_VALUES_BEFORE: {
            key: 'attributesValuesBefore',
            entity: 'keys.common.before',
            namespace: nsHistorics
        },
        ATTRIBUTES_VALUES_AFTER: {
            key: 'attributesValuesAfter',
            entity: 'keys.common.after',
            namespace: nsHistorics
        },
        OUTCOME: {
            key: 'outcome',
            type: FIELD_TYPES.BADGE,
            entity: 'keys.common.outcome',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.SELECT,
            enum: HISTORICS_OUTCOME_TYPE,
            prefix: 'historics_outcome_'
        }
    },
    SIM_CARDS_HISTORICS: {
        SIM_ICCID: {
            key: 'simIccid',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.sim_cards.iccid',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.sim_cards.iccid'
        }
    },
    POS_TERMINALS_HISTORICS: {
        SERIAL_NUMBER: {
            key: 'serialNumber',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.pos_terminals.serial_number',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.pos_terminals.serial_number'
        },
        MANUFACTURER: {
            key: 'manufacturer',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.pos_terminals.manufacturer',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.pos_terminals.manufacturer'
        },
        LABEL: {
            key: 'label',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.pos_terminals.label',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.pos_terminals.label'
        },
        CUSTOM_LABEL: {
            key: 'customLabel',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.pos_terminals.custom_label',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.pos_terminals.custom_label'
        }
    },
    USERS_HISTORICS: {
        EMAIL: {
            key: 'email',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.users.email',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.users.email'
        },
        TYPE: {
            key: 'type',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.users.type',
            namespace: nsHistorics,
            enableSorting: true,
            filter: FILTER_TYPES.SELECT,
            enum: HISTORICS_USER_TYPE
        }
    }
};